/**
 * Sanitize a national phone number by removing all non-digit characters,
 * leading zeros, and enforcing a max digit length.
 *
 * @param rawValue - The raw national phone number input.
 * @param maxDigits - Max digits to keep after sanitizing.
 * @returns The sanitized national phone number.
 */
export const sanitizeNationalNumber = (
  rawValue?: string,
  maxDigits = 9,
): string =>
  (rawValue ?? '').replace(/\D/g, '').replace(/^0+/, '').slice(0, maxDigits);
